import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: { insurances: url },
} = config

const getInfoInsurances = () => axios.get(url, { headers: getHeaders(true) })

export default { getInfoInsurances }
